import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import './App.css';
import "react-toastify/dist/ReactToastify.css";

import { AuthProvider } from "./hooks/useAuth";
import PrivateRoute from "./components/PrivateRoute";
import PublicRoute from "./components/PublicRoute";

import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import Dashboard from "./pages/Dashboard";
import DashboardPage from "./pages/DashboardPage";
import AuthLayout from "./components/layouts/AuthLayout";
import DashboardLayout from "./components/layouts/DashboardLayout";
import PublicLayout from "./components/layouts/PublicLayout";
import { toast, ToastContainer } from "react-toastify";
import ProfilePage from "./pages/ProfilePage";
import LogoManagement from "./pages/LogoManagement";
import apiClient from "./utils/apiClient";
import { useDispatch } from "react-redux";
import { getImageFullUrl, pageRoute, siteData } from "./utils/common";
import SliderManagement from "./pages/SliderManagement";
import CategoryManagement from "./pages/CategoryManagement";
import ProductAddPage from "./pages/ProductAddPage";
import ProductListPage from "./pages/ProductListPage";
import ProductView from "./pages/ProductView";
import VendorView from "./pages/VendorView";
import CategoryBannerList from "./pages/CategoryBannerList";
import BannerList from "./pages/BannerList";
import UserListPage from "./pages/UserList";
import VendorListPage from "./pages/VendorListPage";
import OrderTable from "./pages/OrderTable";
import NewsletterList from "./pages/NewsletterList";
import ContactUsList from "./pages/ContactUsList";
import CouponsPage from "./pages/CouponsPage";
import { setFavicon } from "./utils/setFavicon";
import AdminProductManager from "./components/AdminProductControls";
import AdminReviewList from "./pages/AdminReviewList";
import AdminReturnList from "./pages/AdminReturnList";
import OrderDetails from "./pages/OrderDetails";
import AdminRefundManagement from "./pages/Adminrefundmanagement";
import PayoutManagement from "./pages/Payoutmanagement";
 
function App() {
  // const dispatch = useDispatch()

  // const fetchLogo = async () => {
  //   try {
  //     const res = await apiClient.get("/api/logo");
  //     dispatch({ key: 'logo', value: res?.data?.data?.logoUrl, type: 'SET_VALUE' })
  //     setFavicon(getImageFullUrl(res?.data?.data?.logoUrl)); // ✅ set favicon dynamically

  //   } catch (err) {
  //     toast.error(err.response?.data?.message || "Failed to fetch logo");
  //   }
  // };

  useEffect(() => {
    setFavicon('/logo.png'); // ✅ set favicon dynamically
    // fetchLogo()
  }, [])

  useEffect(() => {
    document.title = siteData.name;
  }, []);

  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Auth Pages (Login / Signup) */}
          <Route

            element={
              <PublicRoute>
                <AuthLayout />
              </PublicRoute>
            }
          >
            <Route path={pageRoute.login} element={<Login />} />
            <Route path={pageRoute.signUp} element={<SignUp />} />
          </Route>

          {/* Dashboard Pages */}
          <Route

            element={
              <PrivateRoute>
                <DashboardLayout />
              </PrivateRoute>
            }
          >
            {/* <Route path={pageRoute.dashboard} element={<Dashboard />} /> */}
            {/* <Route path={pageRoute.dashboard} element={<DashboardPage />} /> */}
            <Route path={pageRoute.contactUsList} element={<ContactUsList />} />
            <Route path={pageRoute.coupons} element={<CouponsPage />} />
            <Route path={pageRoute.order} element={<OrderTable />} />
            <Route path={`${pageRoute.orderView}:orderId`} element={<OrderDetails />} />

            <Route path={pageRoute.newsLatter} element={<NewsletterList />} />
            <Route path={pageRoute.profile} element={<ProfilePage />} />
            <Route path={pageRoute.categoryBanner} element={<CategoryBannerList />} />
            <Route path={pageRoute.bannerList} element={<BannerList />} />
            {/* <Route path={pageRoute.logoManagement} element={<LogoManagement />} /> */}
            <Route path={pageRoute.sliderManagement} element={<SliderManagement />} />
            <Route path={pageRoute.categoryManagement} element={<CategoryManagement />} />
            {/* <Route path={pageRoute.productAdd} element={<ProductAddPage />} /> */}
            <Route path={pageRoute.productList} element={<ProductListPage />} />
            <Route path={pageRoute.riviewList} element={<AdminReviewList />} />
            {/* <Route path={pageRoute.returnList} element={<AdminReturnList />} /> */}
            <Route path={pageRoute.userList} element={<UserListPage />} />
            <Route path={pageRoute.payoutManagement} element={<PayoutManagement />} />
            <Route path={pageRoute.refundManagement} element={<AdminRefundManagement />} />
            <Route path={pageRoute.vendorList} element={<VendorListPage />} />
            <Route path={`${pageRoute.vendorView}:vendorId`} element={<VendorView />} />
            <Route path={`${pageRoute.productView}:productId`} element={<ProductView />} />
            <Route path={`${pageRoute.productEdit}:productId`} element={<AdminProductManager />} />
          </Route>

          {/* Public Website Pages */}
          <Route element={<PublicLayout />}>
            {/* <Route path="/about" element={<h1>About</h1>} />
            <Route path="/contact" element={<h1>COntact</h1> }/> */}
          </Route>

          {/* Default Redirect */}
          <Route path="*" element={<Navigate to={pageRoute.sliderManagement} replace />} />
        </Routes>
      </Router>
      <ToastContainer autoClose={1500} style={{ maxWidth: '80%' }} />
    </AuthProvider>
  );
}

export default App;

